import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@gray/domain/http/api.service';

/**
 * The videos and live streams one of the coach's students can open, seen through that student.
 * The API answers with the student's own library — level filters, trial locks and all — so the
 * coach assigns from exactly what is on the student's screen.
 *
 * The period is named on every call; the panel never sends the `x-preferred-period` header.
 */
@Injectable({providedIn: 'root'})
export class CoachStudentContentService {

  constructor(
    private api: ApiService,
  ) {
  }

  private prefix(studentId: number): string {
    return `/coach/students/${studentId}`;
  }

  private withPeriod(periodId?: number | null, extra = ''): string {
    const parts = [periodId ? `periodId=${periodId}` : '', extra].filter(part => !!part);
    return parts.length ? `?${parts.join('&')}` : '';
  }

  getVideos(studentId: number, periodId?: number | null, queryString = ''): Observable<any> {
    return this.api.get(`${this.prefix(studentId)}/videos`, this.withPeriod(periodId, queryString));
  }

  getVideo(studentId: number, videoId: number, periodId?: number | null): Observable<any> {
    return this.api.get(`${this.prefix(studentId)}/videos/${videoId}`, this.withPeriod(periodId));
  }

  getLiveStreams(studentId: number, periodId?: number | null, queryString = ''): Observable<any> {
    return this.api.get(`${this.prefix(studentId)}/live-streams`, this.withPeriod(periodId, queryString));
  }

  getLiveStream(studentId: number, liveStreamId: number, periodId?: number | null): Observable<any> {
    return this.api.get(`${this.prefix(studentId)}/live-streams/${liveStreamId}`, this.withPeriod(periodId));
  }
}
